const translations = {
  "Weekly Metrics": "Wöchentliche Kennzahlen",
  "Total initial capital": "Gesamtes Anfangskapital",
  "Initial capital": "Anfangskapital",
  "Week": "Woche",
  "Profit": "Gewinn",
  "Net Profit": "Nettogewinn",
  "Return on Initial Equity": "Rendite auf Anfangskapital",
  "Return on Total Equity": "Rendite auf Gesamtkapital",
  "Trades": "Trades",
  "Profit Factor": "Gewinnfaktor",
  "Percent Profitable Trades": "Prozent Profitable Trades",
  "TradeList": "Handelsliste",
  "Search": "Suche",
  "Source": "Quelle",
  "Type": "Typ",
  "Date": "Datum",
  "Price": "Preis",
  "Quantity": "Menge",
  "Cumulative Profit": "Kumulativer Gewinn",
  "Cumulative Profit %": "Kumulativer Gewinn %",
  "Settings": "Einstellungen",
  "Show file info on import page": "Dateiinformationen auf der Importseite anzeigen",
  "Dark Mode": "Dunkelmodus",
  "Show Currency Symbol": "Währungssymbol anzeigen",
  "Currency Symbol": "Währungssymbol",
  "Language": "Sprache",
  "Monthly Metrics": "Monatliche Kennzahlen",
  "Month": "Monat",
  "Import Data": "Daten importieren",
  "Drag & drop some files here, or click to select files": "Dateien hierher ziehen oder klicken, um Dateien auszuwählen",
  "Show file infos": "Dateiinformationen anzeigen",
  "Include All": "Alle einbeziehen",
  "Include None": "Keine einbeziehen",
  "Remove All": "Alle entfernen",
  "Include": "Einbeziehen",
  "Name": "Name",
  "File Name": "Dateiname",
  "Lines": "Zeilen",
  "Initial Equity": "Anfangskapital",
  "Recalculated Initial Equity": "Berechnetes Anfangskapital",
  "No files uploaded yet.": "Noch keine Dateien hochgeladen.",
  "Confirm Deletion": "Löschung bestätigen",
  "Are you sure you want to delete": "Sind Sie sicher, dass Sie löschen möchten",
  "the file named": "die Datei namens",
  "all files": "alle Dateien",
  "Cancel": "Abbrechen",
  "Confirm": "Bestätigen",
  "Dashboard": "Dashboard",
  "Reports": "Berichte",
  "Analytics": "Analytik",
  "Logout": "Abmelden",
  "Main": "Hauptmenü",
  "Instructions": "Anleitung",
  "Imports": "Importe",
  "Metrics": "Kennzahlen",
  "Periodical Returns": "Periodische Renditen",
  "Annual": "Jährlich",
  "Monthly": "Monatlich",
  "Weekly": "Wöchentlich",
  "Daily": "Täglich",
  "Visuals": "Visualisierungen",
  "Equity Graphs": "Gewinn-Diagramme",
  "Drawdown Graphs": "Drawdown-Diagramme",
  "Others": "Andere",
  "Disclaimer": "Haftungsausschluss",
  "Metric": "Metrik",
  "Value": "Wert",
  "Initial Capital": "Anfangskapital",
  "Total Net Profit": "Gesamtnettogewinn",
  "Gross Profit": "Bruttogewinn",
  "Gross Loss": "Bruttoverlust",
  "Pessimistic RR": "Pessimistischer RR",
  "Total Trades": "Gesamthandel",
  "Winning Trades": "Gewinnhandel",
  "Losing Trades": "Verlusthandel",
  "Avg Trade Net Profit": "Durchschnittlicher Nettogewinn pro Handel",
  "Avg Winning Trade": "Durchschnittlicher Gewinnhandel",
  "Avg Losing Trade": "Durchschnittlicher Verlusthandel",
  "Largest Win": "Größter Gewinn",
  "Max Cons Winners": "Max Cons Gewinner",
  "Largest Loss": "Größter Verlust",
  "Max Cons Losers": "Max Cons Verlierer",
  "Trading Period": "Handelszeitraum",
  "Total Trading Days": "Gesamthandelstage",
  "Longest Flat Period Days": "Längste flache Periode",
  "Max Drawdown": "Max Drawdown",
  "Max Drawdown As % Of Initial Equity": "Max Drawdown in % des Anfangskapitals",
  "Max Drawdown As % Of Total Equity": "Max Drawdown in % des Gesamtkapitals",
  "Max Drawdown Date": "Datum des Max Drawdown",
  "Max Intraday Drawdown": "Max Intraday Drawdown",
  "Max Intraday Drawdown As % Of Initial Equity": "Max Intraday Drawdown in % des Anfangskapitals",
  "Max Intraday Drawdown As % Of Total Equity": "Max Intraday Drawdown in % des Gesamtkapitals",
  "Max Intraday Drawdown Date": "Datum des Max Intraday Drawdown",
  "Longest Drawdown Days": "Längste Drawdown-Tage",
  "Recovery Factor": "Erholungsfaktor",
  "NP Max DD": "NP Max DD",
  "NP Intraday Max DD": "NP Intraday Max DD",
  "Avg Worst 5 DD": "Durchschnitt der 5 schlechtesten DD",
  "Avg Worst 5 DD As % Of Initial Equity": "Durchschnitt der 5 schlechtesten DD in % des Anfangskapitals",
  "Max Runup": "Max Runup",
  "Max Runup As % Of Initial Equity": "Max Runup in % des Anfangskapitals",
  "Max Runup As % Of Total Equity": "Max Runup in % des Gesamtkapitals",
  "Max Runup Date": "Datum des Max Runup",
  "Longest Runup Days": "Längste Runup-Tage",
  "Margin Requirements": "Marginanforderungen",
  "Return on Initial Capital": "Rendite auf Anfangskapital",
  "Annual Rate of Return": "Jährliche Rendite",
  "Avg Monthly Return": "Durchschnittliche monatliche Rendite",
  "Std Dev Monthly Return": "Standardabweichung der monatlichen Rendite",
  "Percent Profitable Months": "Prozent rentabler Monate",
  "Sharpe Ratio": "Sharpe-Ratio",
  "Sortino Ratio": "Sortino-Ratio",
  "Sterling Ratio": "Sterling-Ratio",
  "MAR Ratio": "MAR-Ratio",
  "Efficiency Factor": "Effizienzfaktor",
  "How to Import Your Trading Data:": "So importieren Sie Ihre Handelsdaten:",
  "Note: There are still calculation bugs. Please use with care.": "Hinweis: Es gibt noch Berechnungsfehler. Bitte vorsichtig verwenden.",
  "Step 1:": "Schritt 1:",
  "Export CSV Files from TradingView:": "CSV-Dateien von TradingView exportieren:",
  "Open the tab as shown in the image above.": "Öffnen Sie die Registerkarte wie im Bild oben gezeigt.",
  "Click the Download button (also highlighted in the image) to export your trading list as CSV files.": "Klicken Sie auf die Schaltfläche Herunterladen (ebenfalls im Bild hervorgehoben), um Ihre Handelsliste als CSV-Dateien zu exportieren.",
  "Step 2:": "Schritt 2:",
  "Upload CSV Files to the Application:": "CSV-Dateien in die Anwendung hochladen:",
  'Navigate to the "Manage Data" page from the menu.': 'Navigieren Sie im Menü zur Seite "Daten verwalten".',
  "Upload the exported CSV files.": "Laden Sie die exportierten CSV-Dateien hoch.",
  "Step 3:": "Schritt 3:",
  "Manage Uploaded Files:": "Hochgeladene Dateien verwalten:",
  "Each uploaded file can be included in calculations by selecting it.": "Jede hochgeladene Datei kann in die Berechnungen einbezogen werden, indem sie ausgewählt wird.",
  "You can assign a custom name to each file for better identification.": "Sie können jeder Datei einen benutzerdefinierten Namen zuweisen, um sie besser zu identifizieren.",
  "Step 4:": "Schritt 4:",
  "Initial Equity Adjustment:": "Anpassung des Anfangskapitals:",
  "The initial amount of equity is estimated by reverse-calculating from your trading data. However, this may not always produce accurate results.": "Der anfängliche Kapitalbetrag wird durch Rückrechnung aus Ihren Handelsdaten geschätzt. Dies kann jedoch nicht immer genaue Ergebnisse liefern.",
  "After uploading each file, you can manually edit and input the correct initial equity if needed.": "Nach dem Hochladen jeder Datei können Sie das anfängliche Kapital manuell bearbeiten und eingeben, falls erforderlich.",
  "Follow these steps to ensure accurate calculations and proper management of your trading data.": "Befolgen Sie diese Schritte, um genaue Berechnungen und eine ordnungsgemäße Verwaltung Ihrer Handelsdaten sicherzustellen.",
  "Loading the magic": "Lade die Magie",
  "Summoning the data wizards": "Beschwörung der Datenzauberer",
  "Hold tight, data incoming": "Halten Sie sich fest, Daten kommen",
  "Just a moment, making things awesome": "Einen Moment, wir machen die Dinge großartig",
  "Data elves are at work": "Datenelfen sind bei der Arbeit",
  "Brewing some data potions": "Brauen von Datenzaubertränken",
  "Hang on, crunching numbers": "Warten Sie, wir knacken Zahlen",
  "Data is on its way": "Daten sind unterwegs",
  "Almost there, stay tuned": "Fast da, bleiben Sie dran",
  "Fetching unicorns": "Einhörner holen",
  "Aligning the stars": "Ausrichtung der Sterne",
  "Polishing the data crystals": "Polieren der Datenkristalle",
  "Warming up the servers": "Aufwärmen der Server",
  "Gathering the bytes": "Sammeln der Bytes",
  "Charging the flux capacitor": "Laden des Flux-Kompensators",
  "Calibrating the data matrix": "Kalibrierung der Datenmatrix",
  "Spinning up the hamster wheels": "Ankurbeln der Hamsterräder",
  "Consulting the oracles": "Beratung der Orakel",
  "Synchronizing the clocks": "Synchronisierung der Uhren",
  "Yearly Metrics": "Jährliche Kennzahlen",
  "Daily Metrics": "Tägliche Kennzahlen",
  "January": "Januar",
  "February": "Februar",
  "March": "März",
  "April": "April",
  "May": "Mai",
  "June": "Juni",
  "July": "Juli",
  "August": "August",
  "September": "September",
  "October": "Oktober",
  "November": "November",
  "December": "Dezember",
  "Trading Metrics": "Handelskennzahlen",
  "Loading...": "Laden...",
  "Config": "Konfiguration",
  "Config File Name": "Konfigurationsdatei",
  "No config file": "Keine Konfigurationsdatei",
  "Config File Content": "Inhalt der Konfigurationsdatei",
  "Confirm Config Deletion": "Konfigurationslöschung bestätigen",
  "Are you sure you want to delete the config file for": "Sind Sie sicher, dass Sie die Konfigurationsdatei für löschen möchten",
  "Close": "Schließen",
  "tradingRange": "Handelsbereich",
  "backtestingRange": "Backtesting-Bereich",
  "symbol": "Symbol",
  "timeframe": "Zeitrahmen",
  "chartType": "Diagrammtyp",
  "pointValue": "Punktwert",
  "currency": "Währung",
  "tickSize": "Tick-Größe",
  "precision": "Präzision",
  "initialCapital": "Anfangskapital",
  "orderSize": "Auftragsgröße",
  "pyramiding": "Pyramiding",
  "commission": "Kommission",
  "slippage": "Slippage",
  "verifyPriceForLimitOrders": "Preis für Limitaufträge überprüfen",
  "marginForLongPositions": "Marge für Long-Positionen",
  "marginForShortPositions": "Marge für Short-Positionen",
  "recalculateAfterOrderIsFilled": "Nach Auftragserfüllung neu berechnen",
  "recalculateOnEveryTick": "Bei jedem Tick neu berechnen",
  "recalculateOnBarClose": "Bei Balkenschluss neu berechnen",
  "backtestingPrecisionUseBarMagnifier": "Backtesting-Präzision Lupe verwenden",
  "Expert Mode": "Expertenmodus",
  "totalNetProfit": "Gesamtnettogewinn",
  "grossProfit": "Bruttogewinn",
  "grossLoss": "Bruttoverlust",
  "profitFactor": "Gewinnfaktor",
  "totalTrades": "Gesamthandel",
  "winningTradesCount": "Gewinnhandel",
  "losingTradesCount": "Verlusthandel",
  "percentProfitable": "Prozent Profitable Trades",
  "avgTradeNetProfit": "Durchschnittlicher Nettogewinn pro Handel",
  "avgWinningTrade": "Durchschnittlicher Gewinnhandel",
  "avgLosingTrade": "Durchschnittlicher Verlusthandel",
  "largestWin": "Größter Gewinn",
  "largestLoss": "Größter Verlust",
  "maxDrawdown": "Max Drawdown",
  "maxDrawdownDate": "Datum des Max Drawdown",
  "annualRateOfReturn": "Jährliche Rendite",
  "sharpeRatio": "Sharpe-Ratio",
  "sortinoRatio": "Sortino-Ratio",
  "sterlingRatio": "Sterling-Ratio",
  "marRatio": "MAR-Ratio",
  "efficiencyFactor": "Effizienzfaktor",
  "returnOnInitialCapital": "Rendite auf Anfangskapital",
  "marginRequirements": "Marginanforderungen",
  "maxDrawdownAsPercentOfInitialEquity": "Max Drawdown in % des Anfangskapitals",
  "maxDrawdownAsPercentOfTotalEquity": "Max Drawdown in % des Gesamtkapitals",
  "maxIntradayDrawdownAsPercentOfInitialEquity": "Max Intraday Drawdown in % des Anfangskapitals",
  "maxIntradayDrawdownAsPercentOfTotalEquity": "Max Intraday Drawdown in % des Gesamtkapitals",
  "recoveryFactor": "Erholungsfaktor",
  "npMaxDD": "NP Max DD",
  "npIntradayMaxDD": "NP Intraday Max DD",
  "avgWorst5DD": "Durchschnitt der 5 schlechtesten DD",
  "maxRunupAsPercentOfInitialEquity": "Max Runup in % des Anfangskapitals",
  "maxRunupAsPercentOfTotalEquity": "Max Runup in % des Gesamtkapitals",
  "maxIntradayRunupAsPercentOfInitialEquity": "Max Intraday Runup in % des Anfangskapitals",
  "maxIntradayRunupAsPercentOfTotalEquity": "Max Intraday Runup in % des Gesamtkapitals",
  "maxIntradayRunupDuration": "Dauer des Max Intraday Runup",
  "maxIntradayRunup": "Max Intraday Runup",
  "maxIntradayRunupDate": "Datum des Max Intraday Runup",
  "Total Wins": "Gesamtgewinne",
  "Total Losses": "Gesamtverluste",
  "Select Metrics": "Metriken Auswählen",
  "Additional Expert Mode Metrics": "Zusätzliche Expertenmodus-Metriken",
  "Select All": "Alle auswählen",
  "Deselect All": "Alle abwählen",
  "Open Metrics Popup": "Metrik-Popup öffnen",
  "View and Select Metrics": "Metriken anzeigen und auswählen",
  "Show Advanced Metrics": "Erweiterte Kennzahlen anzeigen",
  "Monthly Profit and Loss": "Monatlicher Gewinn und Verlust",
  "Monthly Graphs": "Monatliche Diagramme",
  "Profits and Losses": "Gewinne und Verluste",
  "(Optional) How to Import And Remember Your Backtest Configuration:": "(Optional) So importieren und speichern Sie Ihre Backtest-Konfiguration:",
  "Export Configuration:": "Konfiguration exportieren:",
  "Navigate to the 'Configuration' page in the TradingView backtester.": "Navigieren Sie zur Seite 'Konfiguration' im TradingView-Backtester.",
  "Click the 'Export' button to save your current configuration.": "Klicken Sie auf die Schaltfläche 'Exportieren', um Ihre aktuelle Konfiguration zu speichern.",
  "Import Configuration:": "Konfiguration importieren:",
  "Click the 'Import' button in the config column of your entries row and upload the exported csv file.": "Klicken Sie auf die Schaltfläche 'Importieren' in der Konfigurationsspalte Ihrer Eintragszeile und laden Sie die exportierte CSV-Datei hoch.",
  "Manage Configuration:": "Konfiguration verwalten:",
  "You can view your configuration again as needed by clicking on the eye icon.": "Sie können Ihre Konfiguration bei Bedarf erneut anzeigen, indem Sie auf das Augensymbol klicken.",
  "Open the tab 'List of Trades' in the TradingView backtester as shown in the image above.": "Öffnen Sie die Registerkarte 'Liste der Trades' im TradingView-Backtester wie im Bild oben gezeigt.",
  "Use deep backtest": "Deep-Backtest verwenden",
  "Start Date": "Startdatum",
  "End Date": "Enddatum",
  "Active dataset": "Aktives Datenset",
  "Manage Datasets": "Datensets verwalten",
  "Number of Files": "Anzahl der Dateien",
  "First Trade": "Erster Handel",
  "Last Trade": "Letzter Handel",
  "All files": "Alle Dateien",
  "Included files": "Eingeschlossene Dateien",
  "Number of Trades": "Anzahl Trades",
  "Confirm Dataset Deletion": "Datenset-Löschung bestätigen",
  "Are you sure you want to delete the dataset named": "Sind Sie sicher, dass Sie das Datenset namens löschen möchten",
  "Add New Dataset": "Neues Datenset hinzufügen",
  "Dataset Name": "Datenset-Name",
  "Add": "Hinzufügen",
  "Manage Data": "Daten verwalten",
  "Confirm Initial Capital": "Anfangskapital bestätigen",
  "Initial Capital from Config": "Anfangskapital aus der Konfiguration",
  "Add Dataset": "Datenset hinzufügen",
  "Timestamp": "Zeitstempel",
  "days": "Tage",
};

// Reminder: Don't forget to translate the MUI X filter phrases.
export default translations;